import { render, staticRenderFns } from "./pending.vue?vue&type=template&id=ab2c03ea&scoped=true"
import script from "./pending.vue?vue&type=script&lang=js"
export * from "./pending.vue?vue&type=script&lang=js"
import style0 from "./pending.vue?vue&type=style&index=0&id=ab2c03ea&prod&lang=scss"
import style1 from "./pending.vue?vue&type=style&index=1&id=ab2c03ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2c03ea",
  null
  
)

export default component.exports